module.exports = __webpack_public_path__ + "img/bg1.69e33e1c.png";